class FiltersDrawer extends HTMLElement {
  constructor() {
    super();

    this.triggers = document.querySelectorAll(".js-drawer-trigger");
    this.drawer = this.querySelector(".filters__drawer");
    this.close = this.querySelector(".js-drawer-close");
    this.header = document.querySelector(".header");
    this.html = document.querySelector("html");
    this.body = document.querySelector("body");
    this.handleBodyClick = this.handleBodyClickEvent.bind(this);

    this.addListeners();
  }

  addListeners() {
    this.triggers.forEach(trigger => trigger.addEventListener("click", () => this.openDrawer()));
    this.close.addEventListener("click", () => this.closeDrawer());

    subscribe(PUB_SUB_EVENTS.closeFilterDrawer, this.closeDrawer.bind(this));
  }

  handleBodyClickEvent(event) {
    const isDrawer = event.target.closest(".js-drawer-trigger");
    const isTrigger = event.target.closest("filters-drawer");

    if (event.target.closest(".filters__submit") || !isDrawer && !isTrigger) this.closeDrawer();
  }

  openDrawer() {
    this.toggleDrawer("add");

    window.addEventListener("click", this.handleBodyClick, { passive: true });
  }

  closeDrawer() {
    this.toggleDrawer("remove");

    window.removeEventListener("click", this.handleBodyClick);
  }

  toggleDrawer(action) {
    this.html.style.marginRight = action === "add" ? `${window.innerWidth - document.body.clientWidth}px` : "0";
    this.drawer.classList[action]("filters__drawer--active");
    this.html.classList[action]("overflow-hidden");
    this.body.classList[action]("shadow");
  }
}

customElements.define("filters-drawer", FiltersDrawer);